/* eslint-disable no-underscore-dangle */

import Renderer from './plan-status-renderer';

const DefaultColumnComponent = require('@gluenetworks/steve_ui_widgets').GridGl
  .DefaultColumnComponent;

const _ = require('lodash');

class PlanStatusComponent extends DefaultColumnComponent {
  constructor(value, context) {
    super(value);
    this._value = value;
    this._context = context;
    this._renderer = new Renderer(this);
    this._registerListeners();
  }

  /** **************************************** */
  /* START PRIVATE COMPONENT MODEL METHODS   */
  /** **************************************** */

  _registerListeners() {}

  _unregisterListeners() {}

  /** **************************************** */
  /* END PRIVATE COMPONENT MODEL METHODS     */
  /* START PUBLIC COMPONENT MODEL METHODS    */
  /** **************************************** */

  get renderer() {
    return this.getRenderer();
  }

  getRenderer() {
    return this._renderer;
  }

  shutdown() {
    this._unregisterListeners();
    const prom = this._renderer._shutdown();
    this._renderer = undefined;
    this._value = undefined;
    return prom;
  }

  /** **************************************** */
  /* END COMPONENT MODEL METHODS             */
  /* START HANDLER METHODS                   */
  /** **************************************** */

  /** **************************************** */
  /* END HANDLER METHODS                     */
  /* START PRIVATE METHODS                   */
  /** **************************************** */

  /** **************************************** */
  /* END PRIVATE METHODS                     */
  /* START PUBLIC API METHODS                */
  /** **************************************** */

  setValue(newVal) {
    if (!_.isUndefined(newVal)) {
      this.setPlanStatus(newVal);
    }
  }

  getValue() {
    return this.getPlanStatus();
  }

  setPlanStatus(newVal) {
    this._value = newVal;
    this.emit('PlanStatus', newVal);
    return this;
  }

  getPlanStatus() {
    return this._value;
  }

  /** **************************************** */
  /* END PUBLIC API METHODS                  */
  /** **************************************** */
}

export default PlanStatusComponent;
